<script>
export default {
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<template>
  <md-app id="cf-app" md-waterfall md-mode="fixed-last">
    <md-app-toolbar class="md-dense md-primary">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <span class="md-title">QA Game Test</span>
        </div>
      </div>
    </md-app-toolbar>

    <md-app-content>
      <slot />
    </md-app-content>
  </md-app>
</template>

<style lang="scss" scoped>
@import '@design';

#cf-app {
  min-height: 100vh;
}

.cffield {
  display: block;
}
</style>
